var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{on:{"click":function($event){$event.stopPropagation();return _vm.toggle.apply(null, arguments)}}},[_vm._t("default",null,null,{ confirmed: _vm.isConfirmed, count: _vm.count, reset: _vm.reset })],2)
}
var staticRenderFns = []

export { render, staticRenderFns }